import { render, staticRenderFns } from "./OFilePreview.vue?vue&type=template&id=0e154c88&scoped=true&"
import script from "./OFilePreview.vue?vue&type=script&lang=js&"
export * from "./OFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e154c88",
  null
  
)

export default component.exports